import { axiosInstance, parseResult } from "./CommonApi";

export const getDeviceModels = async () => {
  const response = await axiosInstance.get("/rtu/device-model/");
  return parseResult(response);
};

export const createDeviceModel = async (payload) => {
  const response = await axiosInstance.post("/rtu/device-model/", payload);
  return parseResult(response);
};

export const updateDeviceModel = async (id, payload) => {
  const response = await axiosInstance.put(
    `/rtu/device-model/${id}/`,
    payload
  );
  return parseResult(response);
};

export const deleteDeviceModels = async (ids) => {
  const response = await axiosInstance.delete("/rtu/device-model/", {
    data: { ids },
  });
  return parseResult(response);
};
